export interface BarChartProps {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
  labels?: string[];
}

export function BarChart({
  data,
  width = 480,
  height = 180,
  color = 'var(--dg-accent-500)',
  labels,
}: BarChartProps) {
  if (!data.length) return null;
  const max = Math.max(...data) * 1.15;
  const padL = 28;
  const padB = 22;
  const padT = 8;
  const innerW = width - padL - 8;
  const innerH = height - padT - padB;
  const barW = innerW / data.length;
  const ticks = [0, 0.5, 1].map((t) => Math.round(max * t));

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'block', overflow: 'visible' }}
    >
      {ticks.map((t, i) => {
        const y = padT + innerH - (t / max) * innerH;
        return (
          <g key={i}>
            <line
              x1={padL}
              x2={width - 8}
              y1={y}
              y2={y}
              stroke="var(--dg-border)"
              strokeWidth="1"
              strokeDasharray={i === 0 ? '0' : '2 3'}
            />
            <text x={padL - 6} y={y + 3} textAnchor="end" fontSize="10" fill="var(--dg-text-3)">
              {t}
            </text>
          </g>
        );
      })}
      {data.map((v, i) => {
        const h = (v / max) * innerH;
        const x = padL + i * barW + barW * 0.18;
        const y = padT + innerH - h;
        const w = barW * 0.64;
        return (
          <g key={i}>
            <rect x={x} y={y} width={w} height={h} rx="2" fill={color} opacity={i === data.length - 1 ? 1 : 0.7} />
            {labels && labels[i] && (
              <text
                x={x + w / 2}
                y={padT + innerH + 14}
                textAnchor="middle"
                fontSize="10"
                fill="var(--dg-text-3)"
              >
                {labels[i]}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}
